import { render } from "./UsageListHolder.vue?vue&type=template&id=be5ea02a&scoped=true"
import script from "./UsageListHolder.vue?vue&type=script&lang=ts"
export * from "./UsageListHolder.vue?vue&type=script&lang=ts"

import "./UsageListHolder.vue?vue&type=style&index=0&id=be5ea02a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be5ea02a"

export default script